/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { closelightbox } from "../../util/Functions";
import { Button, IconButton, Dialog, Typography, TextField, DialogActions, MenuItem, Grid, DialogTitle, DialogContent } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { makeStyles } from "@mui/styles";
import { Close } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
  paper: { minWidth: "700px" },
  root: {    
    margin: "auto", color: "red", height: "30px", width: "100%", textAlign: "center", backgroundColor: "rgb(253, 196, 196)", border: "transparent", paddingTop: "8px", paddingBottom: "30px", marginLeft: "14px",
  }
}));

const PldModalForm = (props) => {
  const classes = useStyles();
  const [zPos, setZPos] = useState(45)
  var [hasTrxOp, setHasTrxOp] = useState(false);
  const [titleForm, setTitleForm] = useState("");
  const [fullname, setFullName] = useState("");
  const [country, setCountry] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [msnError, setMsnError] = useState("");
  const [trxUuid, setTrxUuid] = useState("");
  const [trxUdade, settrxUdate] = useState("");
  const [fields, setFields] = useState([]);
  const [spaceUuid, setSpaceUuid] = useState("");
  const [loading, setLoading] = useState(false);
  var formType = "";
  const [invoicingCustomer, setInvoicingCustomer] = useState({
    country: "", extnum: "", intnum: "", locality: "", reference: "", state: "", street: "", town: "", zip: "",
  });

  useEffect(() => {
    if (props.data.form.length > 0) {
      let customerAux = props.data.customer;
      let fieldsAux = props.data.form;

      setFields(fieldsAux)
      setTitleForm(props.data.titleForm);
      setFullName(props.data.fullname);
      setCountry(props.data.country);
      setInvoicingCustomer(props.data.invoicingCustomer);
      settrxUdate(props.data.trxUdade);
      setCustomer(customerAux);
      setHasTrxOp(props.data.hasTrxOp);

      if (props.data.hasTrxOp) {
        setTrxUuid(props.data.trxUuid);
        setSpaceUuid(props.data.spaceUuid);
      }

      formType = props.data.formType;
      getAdrressByCp(customerAux.domicilio.codigo_postal).then((resp) => {
        let coloniasAux = [];
        let codigoPostal: any = resp;
        let ciudad_poblacion = "";
        if (codigoPostal !== undefined) {
          codigoPostal.colonias.map((col) => {
            coloniasAux.push({
              key: col.clave,
              label: col.nombre,
            });
          });
          if (codigoPostal.nombre_municipio) {
            ciudad_poblacion = codigoPostal.nombre_municipio;
          }

          fieldsAux.map((ele) => {
            if (ele.findValue === "colonia") {
              ele.values = coloniasAux;
            }
            if (ele.findValue === "ciudad_poblacion") {
              ele.value = ciudad_poblacion;
            }
          });
          setFields(fieldsAux);
        }
      });
    }
  }, []);

  const [customer, setCustomer] = useState({
    uuid: "",
    numero_cuenta_proyecto: "",
    cuenta_asociada_institucion: "",
    nombre_apoderado: "",
    apellido_paterno_apoderado: "",
    apellido_materno_apoderado: "",
    domicilio: {
      entidad_federativa: "",
      calle: "",
      colonia: "",
      ciudad_poblacion: "",
      codigo_postal: "",
    },
  });

  const disableValidate = (msn) => {
    setMsnError(msn);
    props.changeLoader(false);
    setZPos(45)
    setDisabled(false);
    setLoading(false);
  };

  const getAdrressByCp = async (cp) => {
    props.changeLoader(true);
    setZPos(-1)
    setLoading(true);
    setDisabled(true);
    return await codigoPostalRequest(cp);
  };

  const codigoPostalRequest = async (cp) => {
    props.changeLoader(true);
    setZPos(-1)
    let request = await API.service("codigoPostal", cp, props.pos, props.changeAlert, props.changeLoader, props.history );
    if (request.status === 200) {
      if (request.data.data.response === "OK") {
        props.changeLoader(false);
        setZPos(45)
        setLoading(false);
        setDisabled(false);
        return request.data.data.widget[0].content[0];
      } else {
        setLoading(false);
        setDisabled(false);
        props.changeLoader(false);
        setZPos(45)
        return {};
      }
    }
  };

  const validateForm = (f) => {
    let requires = 0;
    let values = 0;
    for (let i = 0; i < f.length; i++) {
      if (f[i]["required"]) {
        requires++;
        if (f[i]["value"]) {
          if (f[i]["value"].toString().length > 0) {
            values++;
          }
        }
      }
    }
    if (values >= requires) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const changeValue = async (index, e) => {
    let f = fields;
    let cp = e.target.value;

    if (f[index]["findValue"] === "codigo_postal" && cp.length === 5) {
      props.changeLoader(true);
      setZPos(-1)
      disableValidate("");
      setMsnError("");
      getAdrressByCp(cp).then((resp) => {
        let codigoPostal: any = resp;
        if (codigoPostal !== undefined) {
          let ent_fed = {
            k: "",
            v: "",
          };
          props.states.forEach((ele) => {
            if (ele.k === codigoPostal.clave_estado) {
              ent_fed = ele;
            }
          });
          for (let k = 0; k < f.length; k++) {
            if (f[k]["findValue"] === "colonia") {
              let values = [];
              codigoPostal.colonias.map((col) => {
                values.push({
                  key: col.clave,
                  label: col.nombre,
                });
              });
              f[k]["value"] = "";
              f[k]["values"] = values;
            }
            if (f[k]["findValue"] === "ciudad_poblacion") {
              f[k]["value"] = codigoPostal.nombre_municipio;
            }
            if (f[k]["findValue"] === "calle_domicilio") {
              f[k]["value"] = invoicingCustomer.street;
            }
            if (f[k]["findValue"] === "entidad_federativa_domicilio") {
              f[k]["value"] = ent_fed.v;
            }
          }

          setCustomer({
            uuid: props.data.customer.uuid,
            numero_cuenta_proyecto: "",
            cuenta_asociada_institucion: "",
            nombre_apoderado: "",
            apellido_paterno_apoderado: "",
            apellido_materno_apoderado: "",
            domicilio: {
              entidad_federativa: ent_fed.k,
              calle: invoicingCustomer.street,
              colonia: "",
              ciudad_poblacion: codigoPostal.clave_municipio,
              codigo_postal: cp,
            },
          });

          f[index]["value"] = f[index]["type"] === "number" ? Number(cp) : cp;
          setFields(JSON.parse(JSON.stringify(f)));
          validateForm(f);
          props.changeLoader(false);
          setZPos(45)
        } else {
          disableValidate("CP no encontrado : " + cp);
        }
      });
    } else if (f[index]["findValue"] === "colonia") {
      setCustomer({
        uuid: props.data.customer.uuid,
        numero_cuenta_proyecto: "",
        cuenta_asociada_institucion: "",
        nombre_apoderado: "",
        apellido_paterno_apoderado: "",
        apellido_materno_apoderado: "",
        domicilio: {
          entidad_federativa: customer.domicilio.entidad_federativa,
          calle: invoicingCustomer.street,
          colonia: e.target.value,
          ciudad_poblacion: customer.domicilio.ciudad_poblacion,
          codigo_postal: customer.domicilio.codigo_postal,
        },
      });
      f[index]["value"] =
        f[index]["type"] === "number" ? Number(e.target.value) : e.target.value;
      setFields(JSON.parse(JSON.stringify(f)));
      validateForm(f);
    } else if (f[index]["findValue"] === "uuidClient") {
      let uuid = e.target.value;
      setLoading(true);
      f[index]["value"] = f[index]["type"] === "number" ? Number(uuid) : uuid;
      setFields(JSON.parse(JSON.stringify(f)));
      validateForm(f);
      if (e.target.value.trim().length === 49) {
        let data = {
          data: {
            customer: {
              keyword: uuid.trim()
            },
            filters: {
              results_per_page: 50,
              page_number: 1,
              search_type: "uuid"
            }
          }
        }

        let request = await API.service(
          "dataPersonal",
          data,
          props.pos,
          props.changeAlert,
          props.changeLoader,
          props.history
        );
        if (request.status === 200) {
          if (request.data.data.response === "OK") {
            let customerInfo = request.data.data.widget[0];
            for (let k = 0; k < f.length; k++) {
              if ( f[k]["findValue"] === "nombre_cliente" && customerInfo.content.gname != undefined) {
                f[k]["value"] = customerInfo.content.gname;
              }
              if ( f[k]["findValue"] === "apellido_paterno_cliente" && customerInfo.content.lname != undefined) {
                f[k]["value"] = customerInfo.content.lname;
              }
              if ( f[k]["findValue"] === "apellido_materno_cliente" && customerInfo.content.slname != undefined) {
                f[k]["value"] = customerInfo.content.slname;
              }
              if ( f[k]["findValue"] === "rfc_cliente" && customerInfo.content.taxid != undefined) {
                f[k]["value"] = customerInfo.content.taxid;
              }
              if ( f[k]["findValue"] === "curp_cliente" && customerInfo.content.populationid != undefined) {
                f[k]["value"] = customerInfo.content.populationid;
              }
              if ( f[k]["findValue"] === "fecha_nacimiento_cliente" && customerInfo.content.bdate != undefined) {
                f[k]["value"] = customerInfo.content.bdate;
              }
              if (f[k]["findValue"] === "razon_denominacion_cliente") {
                if ( customerInfo.content.corporate_name && customerInfo.content.corporate_name != undefined) {
                  f[k]["value"] = customerInfo.content.corporate_name;
                }
              }
            }
            setFields(JSON.parse(JSON.stringify(f)));
            validateForm(f);
          }
        }
        setLoading(false);
      }
    } else {
      f[index]["value"] = f[index]["type"] === "number" ? Number(e.target.value) : e.target.value;
      setFields(JSON.parse(JSON.stringify(f)));
      validateForm(f);
    }
    setLoading(false);
  };

  const buildData = (fields) => {
    let data: any = {};
    fields.forEach((element) => {
      data[element.findValue] = element.value;
    });
    return data;
  };

  const textValidate = (field) => {
    if ( field.value !== "" && (field.value.trim().length < field.min || field.value.trim().length > field.max)) {
      disableValidate(field.msg);
      return false;
    }
    return true;
  };

  const notEmpetyValidate = (field) => {
    if (field.value.trim() === "") {
      disableValidate(field.label + " es obligatorio.");
      return false;
    }
    return true;
  };

  const validate = (datas, type, dataRequest) => {
    setMsnError("");
    for (let i = 0; i < datas.length; i++) {
      const field = datas[i];
      if (field.required && field.validacion) {
        switch (field.type) {
          case "text": {
            if (!textValidate(field)) {
              return false;
            }
            break;
          }
          case "select": {
            if (!notEmpetyValidate(field)) {
              return false;
            }
            break;
          }
          case "fecha": {
            if (!notEmpetyValidate(field)) {
              return false;
            }
            break;
          }
          case "textarea": {
            if (!textValidate(field)) {
              return false;
            }
            break;
          }
        }
      }
    }

    //Remover ´,´ del monto
    if (dataRequest.monto !== undefined && dataRequest.monto !== "") {
      var numbers = /^[+-]?\d+(\.\d+)?$/;
      if (!dataRequest.monto.match(numbers)) {
        disableValidate("El monto de la operación debe ser un numéro");
        return false;
      }
      let montoAux = dataRequest.monto;
      dataRequest.monto = montoAux.replace(/,/g, "");
    }

    if (type === "inusual") {
      if ( dataRequest.fecha_fin_perfil !== undefined && dataRequest.fecha_fin_perfil !== "") {
        let date_end = new Date(dataRequest.fecha_fin_perfil).getTime();
        let date_op = new Date(dataRequest.fecha_operacion).getTime();
        if (date_end > date_op) {
          disableValidate("Fecha termino de perfil transaccional debe ser menor o igual a la fecha de operación: " + dataRequest.fecha_operacion.substring(0, 10));
          return false;
        }
      }
      if (dataRequest.fecha_operacion !== undefined && dataRequest.fecha_operacion !== "") {
        let date_operator = new Date(dataRequest.fecha_operacion).getTime();
        let date_start = new Date(dataRequest.fecha_inicio_perfil).getTime();
        if (!(date_operator >= date_start)) {
          disableValidate("La fecha de operacion: " + dataRequest.fecha_operacion.substring(0, 10) + " debe ser mayor o igual a la fecha de inicio de periodo: " + dataRequest.fecha_inicio_perfil);
          return false;
        }
      }
    } else if (type === "internas") {
      if (dataRequest.rfc_cliente !== "") {
        if (dataRequest.tipo_persona_cliente === "1" && dataRequest.rfc_cliente.length !== 13) {
          disableValidate("RFC del cliente debe tener 13 caracteres.");
          return false;
        } else if (dataRequest.tipo_persona_cliente === "3" && dataRequest.rfc_cliente.length !== 12) {
          disableValidate("RFC del cliente debe tener 12 caracteres.");
          return false;
        }
      }
      if ( props.data.hasTrxOp && dataRequest.uuidClient !== undefined && dataRequest.uuidClient.trim() === "") {
        disableValidate("Uuid de cliente relacionado no puede estar en blanco.");
        return false;
      }
    }
    return true;
  };

  const dowloadXML = (xmltext, name, ext) => {
    var filename = name + ext;
    var pom = document.createElement("a");
    var bb = new Blob([xmltext], { type: "text/plain" });
    pom.setAttribute("href", window.URL.createObjectURL(bb));
    pom.setAttribute("download", filename);
    pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
    pom.draggable = true;
    pom.classList.add("dragout");
    pom.click();
  };

  const dateFormate = (date) => {
    if (date !== null && date !== "") {
      return new Date(date).toISOString();
    } else {
      return "";
    }
  };

  const aceptar = async () => {
    props.changeLoader(true);
    setZPos(-1)
    setLoading(true);
    setDisabled(true);
    formType = props.data.formType;
    var data = {};
    var fileName = "";
    var fileExt = "";
    let dataRequest = buildData(fields);
    if ( formType === "personaFisicaConTrxInterna" || formType === "personaFisicaSinTrxInterna" || formType === "personaFisicaConTrxInternaPM" ) {
      let validForm = validate(fields, "internas", dataRequest);
      if (validForm) {
        let fecha_final = dateFormate(dataRequest.fecha);
        let fecha_nac_final = dateFormate(dataRequest.fecha_nacimiento);
        let fecha_dec_final = dateFormate(dataRequest.fecha_deteccion.substring(0, 10));
        let fecha_nas_cli_final = dateFormate(dataRequest.fecha_nacimiento_cliente);

        let clients = [{
            uuid: dataRequest.uuidClient,
            tipo_persona_cliente: dataRequest.tipo_persona_cliente,
            razon_denominacion_cliente: dataRequest.razon_denominacion_cliente,
            nombre_cliente: dataRequest.nombre_cliente,
            apellido_paterno_cliente: dataRequest.apellido_paterno_cliente,
            apellido_materno_cliente: dataRequest.apellido_materno_cliente,
            rfc_cliente: dataRequest.rfc_cliente,
            curp_cliente: dataRequest.curp_cliente,
            fecha_nacimiento_cliente: fecha_nas_cli_final,
            numero_cuenta_cliente: dataRequest.numero_cuenta_cliente,
          },
        ];

        if (formType === "personaFisicaSinTrxInterna") {
          clients = [];
        }

        fileName = "Internas Preocupantes";
        fileExt = ".ITFP";
        data = {
          data: {
            tipo_reporte: "interna_preocupante",
            empleado: {
              uuid_cliente: dataRequest.uuid_cliente,
              pais_nacionalidad: dataRequest.pais_nacionalidad,
              nombre: dataRequest.nombre,
              apellido_paterno: dataRequest.apellido_paterno,
              apellido_materno: dataRequest.apellido_materno,
              genero: dataRequest.genero,
              rfc: dataRequest.rfc,
              curp: dataRequest.curp,
              fecha_nacimiento: fecha_nac_final,
              entidad_nacimiento: dataRequest.entidad_nacimiento,
              telefono: dataRequest.telefono,
              puesto_entidad: dataRequest.puesto_entidad,
              domicilio: customer.domicilio,
            },
            operacion: {
              tipo_operacion_itf: dataRequest.tipo_operacion_itf,
              monto: dataRequest.monto,
              instrumento_monetario: dataRequest.instrumento_monetario,
              moneda: dataRequest.moneda,
              fecha: fecha_final,
            },
            analisis: {
              fecha_deteccion: fecha_dec_final,
              descripcion_perfil_empleado:
                dataRequest.descripcion_perfil_empleado,
              razones_vulnera_pld: dataRequest.razones_vulnera_pld,
              prioridad_reporte: dataRequest.prioridad_reporte,
            },
            clientes: clients,
          },
        };

        let request: any = await API.service( "pld", data, props.pos, props.changeAlert, props.changeLoader, props.history );
        if (request.status !== 200 || request.data.data.response === "BAD") {
          props.changeLoader(false);
          setZPos(45)
          setDisabled(false);
          setLoading(false);
          if ( request.data && request.data !== undefined && request.data.message !== undefined ) {
            props.changeAlert(true, "error", "La sesión ha expirado");
            setMsnError("La sesión ha expirado");
          } else {
            props.changeAlert(true, "error", request.data.data.message);
            setMsnError(request.data.data.message);
          }
        } else {
          props.changeLoader(false);
          setZPos(45)
          setDisabled(false);
          setLoading(false);
          props.changeAlert(true, "success", "Operación realizada");
          let widget = request.data.data.widget[0];
          dowloadXML(widget.content.xml, fileName, fileExt);
          closelightbox();
        }
      }
    }

    if ( formType === "personaFisicaConTrxInusual" || formType === "personaFisicaSinTrxInusual" || formType === "personaMoralSintrxInusual" || formType === "personaMoralContrxInusual" || formType === "personaMoralContrxInusualPM" || formType === "personaFisicaConTrxInusualPM") {
      let validInusual = validate(fields, "inusual", dataRequest);

      if (validInusual) {
        let fecha_inicio_perfil_final = dateFormate(dataRequest?.fecha_inicio_perfil);
        let fecha_deteccion_final = dateFormate(dataRequest?.fecha_deteccion.substring(0, 10));
        //Data nos solicito que la fecha en el formato 2022-02-09T23:59:00.000Z
        let fecha_fin_perfil_final_moment = dataRequest?.fecha_fin_perfil.substring(0, 10) + "T23:59:00.000Z";
        let fecha_operacion_final = dateFormate(dataRequest?.fecha_operacion);

        if (!hasTrxOp) {
          customer.cuenta_asociada_institucion = dataRequest?.cuenta_asociada_institucion;
          customer.numero_cuenta_proyecto = dataRequest?.numero_cuenta_proyecto;
        }
        customer.nombre_apoderado = dataRequest?.nombre_apoderado;
        customer.apellido_paterno_apoderado = dataRequest?.apellido_paterno_apoderado;
        customer.apellido_materno_apoderado = dataRequest?.apellido_materno_apoderado;

        fileName = "Inusual";
        fileExt = ".ITFI";
        data = {
          data: {
            tipo_reporte: "inusual",
            cuenta: {
              uuid: spaceUuid,
            },
            cliente: customer,
            operacion: {
              uuid: trxUuid,
              tipo_operacion_itf: dataRequest?.tipo_operacion_itf,
              instrumento_monetario: dataRequest?.instrumento_monetario,
              fecha_deteccion: fecha_deteccion_final,
              fecha_operacion: fecha_operacion_final,
            },
            analisis: {
              descripcion_operacion: dataRequest?.descripcion_operacion,
              razon_inusual: dataRequest?.razon_inusual,
              fecha_inicio_perfil: fecha_inicio_perfil_final,
              fecha_fin_perfil: fecha_fin_perfil_final_moment,
              tipo_operacion_perfil: dataRequest?.tipo_operacion_perfil,
              prioridad_reporte: dataRequest?.prioridad_reporte,
              alerta: dataRequest?.alerta,
            },
            contraparte: {
              tipo_persona_contraparte: dataRequest?.tipo_persona_contraparte,
              razon_denominacion_contraparte: dataRequest?.razon_denominacion_contraparte,
              nombre_contraparte: dataRequest?.nombre_contraparte,
              apellido_paterno_contraparte: dataRequest?.apellido_paterno_contraparte,
              apellido_materno_contraparte: dataRequest?.apellido_materno_contraparte,
              nacionalidad_cuenta_contraparte: dataRequest?.nacionalidad_cuenta_contraparte,
              institucion_financiera_contraparte: dataRequest?.institucion_financiera_contraparte,
              cuenta_clabe_contraparte: dataRequest?.cuenta_clabe_contraparte,
            },
          },
        };

        let request: any = await API.service( "pld", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status !== 200 || request.data.data.response === "BAD") {
          props.changeLoader(false);
          setZPos(45)
          setDisabled(false);
          setLoading(false);
          if ( request.data && request.data !== undefined && request.data.message !== undefined) {
            props.changeAlert(true, "error", "La sesión ha expirado");
            setMsnError("La sesión ha expirado");
          } else {
            props.changeAlert(true, "error", request.data.data.message);
            setMsnError(request.data.data.message);
          }
        } else {
          props.changeLoader(false);
          setZPos(45)
          setDisabled(false);
          setLoading(false);
          props.changeAlert(true, "success", "Operación realizada");
          let widget = request.data.data.widget[0];
          dowloadXML(widget.content.xml, fileName, fileExt);
          closelightbox();
        }
      }
    }
  };
  
  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth classes={{ paper: classes.paper}}>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          {titleForm}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent style={{overflowY: "hidden"}}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{paddingTop: "0px" }}><hr/></Grid>
						<Grid item xs={12} style={{fontWeight: "bolder", fontSize:"1.1rem", paddingTop: "0px", paddingBottom: "12px" }}>{fullname}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>País de Nacimiento: </strong>{country}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>Ciudad: </strong>{invoicingCustomer.town}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>Colonia: </strong>{invoicingCustomer.locality}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>Calle: </strong>{invoicingCustomer.street}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>Codigo Postal: </strong>{invoicingCustomer.zip}</Grid>
						<Grid item xs={6} style={{paddingTop: "6px" }}><strong>Referencia: </strong>{invoicingCustomer.reference || "N/A"}</Grid>
						{trxUdade !== "" && 
              <Grid item xs={6} style={{paddingTop: "6px" }}><strong>Fecha de la operación: </strong>{trxUdade.substring(0, 10)}</Grid>
            }
            
            <Grid item xs={12}><hr/></Grid>
            {msnError !== "" && <Typography classes={{ root: classes.root}}>{msnError}</Typography>}
            <Grid container spacing={2} sx={{ padding: "2%", paddingRight: "0px" }}>
            {fields.map((item, index) => {
              if (item.show) {
                if (item.type === "text" || item.type === "number") {
                  return (
                    <Grid item xs={6} key={`field-${index}`}>
                      <TextField label={item.label} value={item.value} onChange={changeValue.bind(this, index)} required={item.required} type={item.type} id={`field-${index}`} size="small" fullWidth />
                    </Grid>
                  );
                }
                if (item.type === "select" && !item.catalog) {
                  return (
                    <Grid item xs={6} key={`field-${index}`}>
                      <TextField
                        label={item.label} value={item.value} onChange={changeValue.bind(this, index)} select required={item.required} type={item.type} id={`field-${index}`} size="small" fullWidth >
                          {item?.values?.map((item2, index2) => {
                            return <MenuItem value={item2.key} key={`select-pld-${index2}`}>{item2.label}</MenuItem>
                          })}
                      </TextField>
                    </Grid>
                  );
                }
                if (item.type === "select" && item.catalog) {
                  return (
                    <Grid item xs={6} key={`field-${index}`}>
                      <TextField
                        label={item.label} value={item.value} onChange={changeValue.bind(this, index)} select required={item.required} type={item.type} id={`field-${index}`} size="small" fullWidth >
                          {item?.values?.map((item2, index2) => {
                            return <MenuItem value={item2.k} key={`select-pld-${index2}`}>{item2.v}</MenuItem>
                          })}
                      </TextField>
                    </Grid>
                  );
                }
                if (item.type === "fecha") {
                  return (
                    <Grid item xs={6} key={`field-${index}`}>
                       <TextField
                        label={item.label} value={item.value.substring(0, 10)} onChange={changeValue.bind(this, index)} type="date" placeholder={item.label} id={`field-${index}`} required={item.required} size="small" fullWidth InputLabelProps={{ shrink: true }}/>
                    </Grid>
                  );
                }
                if (item.type === "textarea") {
                  return (
                    <Grid item xs={6} key={`field-${index}`} >
                      <TextField
                        label={item.label} placeholder={item.label} multiline minRows={fields.length %2 == 1 ? 4 : 1} maxRows={4} onChange={changeValue.bind(this, index)} size="small" fullWidth />
                    </Grid>
                  );
                }
              }
            })}
          </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="contained"  disabled={disabled} onClick={aceptar}>Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};
export default PldModalForm;
